import React from 'react';
import {
  Alert,
  Avatar,
  Button,
  Typography,
  createClasses
} from '@p81-common/ui';
import { useTranslation } from 'react-i18next';
import { access, hasAccess, resources } from 'utils/permissions';

interface SelectionAlertProps {
  disableActions?: boolean;
  selectionCount: string;
  styles: ReturnType<typeof createClasses>;
  handleClearAllClick: (event?: React.MouseEvent) => void;
  handleUpdateNetworkClick: (event?: React.MouseEvent) => void;
  handleUpdateServicesClick: (event?: React.MouseEvent) => void;
}

const SelectionAlert = ({
  disableActions,
  selectionCount,
  styles,
  handleClearAllClick,
  handleUpdateNetworkClick,
  handleUpdateServicesClick
}: SelectionAlertProps) => {
  const { t } = useTranslation(['activity']);
  const hasNetworkRolloutWriteAccess = hasAccess([
    resources.CS_NETWORK_ROLLOUT,
    access.WRITE
  ]);
  return (
    <Alert
      id="selectionAlert"
      variant="standard"
      icon={
        <Avatar
          backgroundColor="#266FE2"
          customSize={64}
          initials={selectionCount}
          variant="square"
          className={styles.avatar}
        />
      }
      action={
        <>
          <Button color="third" size="medium" onClick={handleClearAllClick}>
            {t('activity:buttons.CLEAR_ALL')}
          </Button>
          {hasNetworkRolloutWriteAccess && (
            <>
              <Button
                color="third"
                size="medium"
                disabled={disableActions}
                onClick={handleUpdateNetworkClick}
              >
                {t('activity:networkRollout.UPGRADE_NETWORK_BUTTON')}
              </Button>
              <Button
                color="primary"
                size="medium"
                disabled={disableActions}
                onClick={handleUpdateServicesClick}
              >
                {t('activity:networkRollout.UPDATE_SERVICES_BUTTON')}
              </Button>
            </>
          )}
        </>
      }
      GATEWAYS-SELECTED
      className={styles.alert}
    >
      <Typography variant="h4">
        {t('activity:networkRollout.GATEWAYS-SELECTED')}
      </Typography>
    </Alert>
  );
};

export default SelectionAlert;
